import axios from 'axios';
import { ON_BOARDING_ROUTES } from '../../../utils/constatns';
import { BASE_URL } from '../../../../config/environmentConfig';
import { requestErrorHandler } from '../../../utils/newApplicationUtils';
import { merchantActionTypes } from '../action-types';
import { fetchRegularApplicationData } from './application';
import { successAlert } from '../../../components/ToastMessage';
import { POST } from '../../store-helper';
import { IAction } from '../merchant-interfaces';

export const updateApplicationRiskStatus = async ({ dispatch, applicationId, params, handleSuccess, handleError }): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: true });
    await axios.put(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/risk-status`, params);
    handleSuccess();
    await fetchRegularApplicationData({ dispatch, applicationId });
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: false });
  } catch (e) {
    console.log('upDateApplicationRiskStatus error', e);
    requestErrorHandler(e);
    handleError();
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: false });
  }
};
export const updateApplicationOperationStatus = async ({ dispatch, applicationId, params, handleSuccess, handleError }): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: true });
    await axios.put(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/operations-status`, params);
    handleSuccess();
    await fetchRegularApplicationData({ dispatch, applicationId });
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: false });
  } catch (e) {
    console.log('upDateApplicationRiskStatus error', e);
    requestErrorHandler(e);
    handleError();
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: false });
  }
};
export const setNotification = async ({ dispatch, applicationId, notificationType, params, onSuccess, onError }): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: true });
    let URL= `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}`;

    if (notificationType === 'account_manager') {
      URL += '/notify-account-manager';
    } else {
      URL += '/notify-applicant';
    }

    await POST({ pathname: URL, body: params });
    onSuccess();

    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: false });
  } catch (e) {
    console.log('upDateApplicationRiskStatus error', e);
    requestErrorHandler(e);
    dispatch({ type: merchantActionTypes.SET_RISK_MODAL_LOADING, payload: false });
    onError();
  }
};

interface IResendInvitation {
  dispatch: React.Dispatch<IAction>;
  applicationId: string;
  onSuccess?: () => void;
  onError?: () => void;
}

export const reInviteUser = async ({ dispatch, applicationId, onSuccess, onError }: IResendInvitation): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.SET_REINVITE_LOADING, payload: true });

    await POST({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/invite?id=${applicationId}` });

    onSuccess();
    dispatch({ type: merchantActionTypes.SET_REINVITE_LOADING, payload: false });
  } catch (e) {
    dispatch({ type: merchantActionTypes.SET_REINVITE_LOADING, payload: false });
    console.log('reInviteUser error', e);
    onError();
  }
};

export const setApplicationRiskCategory = async ({ dispatch, applicationId, riskCategory }): Promise<void> => {
  try {
    await axios.put(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/risk-category`, { riskCategory });
    await fetchRegularApplicationData({ dispatch, applicationId });
  } catch (e) {
    console.log('setRiskCategory error', e);
    requestErrorHandler(e);
  }
};

export const downloadDocument = async ({ dispatch, applicationId, documentId }): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.SET_DOCUMENT_LOADING, payload: true });
    const response = await axios.get(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/${applicationId}/document/${documentId}`);

    const link = document.createElement('a');
    link.href = response.data;
    link.download = '';
    link.target = '_blank';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    dispatch({ type: merchantActionTypes.SET_DOCUMENT_LOADING, payload: false });
  } catch (e) {
    dispatch({ type: merchantActionTypes.SET_DOCUMENT_LOADING, payload: false });
    console.log('downloadDocument error', e);
    requestErrorHandler(e);
  }
};